import logger from '@/modules/Logger';

export default {
  // disconnect the current connect and leave room
  async disconnect() {
    // release the hidden video track under screen share
    if (this.constraints.screen && this.localVideoTrack) {
      this.localVideoTrack.close();
    }

    // Release virtual background resources. disable() and release() are guarded
    // separately so a rejected disable() does not skip release() — release() is
    // what frees the processor's allocated resources, so it must run even if
    // disable() fails (otherwise VB resources leak after the lesson ends).
    try {
      await this.vbProcessor?.disable();
    } catch (e) {
      logger.debug('[Agora] Error disabling VB processor during disconnect', {
        operation: 'vbackground:cleanup',
        reason: e.message
      });
    }
    try {
      await this.vbProcessor?.release();
    } catch (e) {
      logger.debug('[Agora] Error releasing VB processor during disconnect', {
        operation: 'vbackground:cleanup',
        reason: e.message
      });
    }
    this.vbPipelined = false;

    // release video and audio resources
    this.localVideoTrack?.close();
    this.localAudioTrack?.close();

    // release device
    this.rtc.localTracks.map(track => { track.close() });

    // diconnect agora client
    await this.rtc.leave();
    logger.info('[Agora] Rtc leave', { operation: 'webrtc:disconnect' })
  }
}

